@if (element) {
<app-mdr-title
    fontSize="16"
    class="dashboard-box-title d-flex m-b-20"
    >{{ element.title }}
    @if (incidentsError || statusServiceError) {
    <span class="ds-icon-error_outline fs-25 error-primary m-l-8 line-height-08"></span>
    }
</app-mdr-title>
@if (isOnboarded) {
<div
    class="main-widgets-container d-flex justify-space-between align-strech"
    id="activity_summary_main_widgets"
    [ngClass]="{ 'height-p-50': allInfoIsEmpty }"
    [ngStyle]="{ 'align-items': allInfoIsEmpty ? 'end' : 'strech' }"
>
    @for (mainWidget of getMainWidgets(); track mainWidget) { @if (!mainWidget.hasPill) {
    <div
        class="main-item text-center d-flex align-end justify-center"
        id="{{ mainWidget.id }}"
    >
        <div class="d-flex flex-direction-column align-center non-pill-container">
            @if (!incidentsLoading && !incidentsError) {
            <div class="d-flex m-b-10">
                @if (!mainWidget.hasPill) {
                <img
                    width="32"
                    src="assets/images/icons/{{ mainWidget.icon }}"
                />
                } @if (incidentsData?.value === 0) {
                <div><span class="ds-icon ds-icon-validation_checked checked-icon fs-32"></span></div>
                } @if (incidentsData?.value > 0) {
                <span class="item--value fs-32">{{ incidentsData?.value }}</span>
                }
            </div>
            } @if (!incidentsError && !incidentsLoading) {
            <div>
                {{ getIncidentsTitlte(incidentsData?.value) }}
            </div>
            } @if (incidentsError) {
            <div class="d-flex align-center m-b-7">
                @if (!mainWidget.hasPill) {
                <img
                    style="background-color: #ffffff"
                    width="32"
                    src="assets/images/icons/{{ mainWidget.icon }}"
                />
                }
                <div class="error-line width-16 height-1"></div>
            </div>
            } @if (incidentsError) {
            <div>
                {{ mainWidget.title }}
            </div>
            } @if (incidentsLoading) {
            <div class="item">
                <div class="item-content d-flex-center justify-center flex-direction-column">
                    <app-mdr-title
                        fontSize="16"
                        class="item--title d-flex widget-title"
                    >
                        <span>{{ mainWidget.title }}</span>
                    </app-mdr-title>
                </div>
            </div>
            <app-mdr-loader
                [ngClass]="incidentsLoading ? 'widget-empty' : 'widget-loading'"
                class="center-loader w-40-percent"
                [rows]="1"
                [columns]="1"
            ></app-mdr-loader>
            }
        </div>
    </div>
    } @if (mainWidget.hasPill) {
    <div class="main-item text-center d-flex align-end justify-center">
        <div class="d-flex flex-direction-column justify-end pill-container align-center h-100 flex-gap-10">
            @if (statusMonitoringData && !statusServiceError && getTextFromEnumId() && !statusLoading) {
            <div
                class="pill align-center width-100 height-35"
                [ngStyle]="{ 'background-color': getServiceColor() }"
            >
                {{ getTextFromEnumId() }}
            </div>
            } @if (statusServiceError) {
            <div class="m-b-10">
                <div class="error-line"></div>
            </div>
            } @if (!statusLoading) {
            <div class="p-t-5">{{ mainWidget.title }}</div>
            } @if (statusLoading) {
            <div class="item">
                <div class="item-content d-flex-center justify-center flex-direction-column">
                    <app-mdr-title
                        fontSize="16"
                        class="item--title d-flex widget-title"
                    >
                        <span>{{ mainWidget.title }}</span>
                    </app-mdr-title>
                </div>
            </div>
            <app-mdr-loader
                [ngClass]="statusLoading ? 'widget-empty' : 'widget-loading'"
                class="center-loader w-40-percent"
                [rows]="1"
                [columns]="1"
            ></app-mdr-loader>
            }
        </div>
    </div>
    } }
</div>
@if (incidentsData && statusMonitoringData) {
<div
    id="activity_summary_basic_widgets_charts"
    class="basic-widgets-container fs-12 m-t-22"
>
    @for (basicWidget of getBasicWidgetsWithCharts(); track basicWidget) { @if (getValueFromResponseMap(basicWidget.title) &&
    calculateSeriesTotal(getValueFromResponseMap(basicWidget.title)?.data) > 0) {
    <div
        class="d-flex justify-space-between m-t-10 height-35 align-center"
        id="{{ basicWidget.id }}"
    >
        <div class="d-flex flex-direction-row">
            <img src="assets/images/icons/{{ basicWidget.icon }}" />
            <span class="m-l-5 width-100">{{ basicWidget.title }}</span>
        </div>
        @if (basicWidget.hasChart && getValueFromResponseMap(basicWidget.title)?.data) {
        <div>
            <app-mdr-dashboard-spike
                [element]="getValueFromResponseMap(basicWidget.title)?.data"
                [chartColor]="basicWidget.chartColor || 'blue'"
                [strokeColors]="basicWidget.strokeColors"
                [chooseFromDataInfo]="basicWidget.chooseFromData"
                [chooseNameFromData]="basicWidget.chooseNameFromData"
            ></app-mdr-dashboard-spike>
        </div>
        } @if (getValueFromResponseMap(basicWidget.title)?.data) {
        <div>
            <b>{{ calculateSeriesTotal(getValueFromResponseMap(basicWidget.title)?.data) }}</b>
        </div>
        }
    </div>
    } }
</div>
}
<div
    id="activity_summary_basic_widgets_withoutcharts"
    class="basic-widgets-container m-t-20"
>
    @for (basicWidget of getBasicWidgetsWithoutCharts(); track basicWidget) { @if (getValueFromResponseMap(basicWidget.title) &&
    getValueFromResponseMap(basicWidget.title)?.data?.value > 0) {
    <div
        class="d-flex justify-space-between m-t-5"
        id="{{ basicWidget.id }}"
    >
        <div class="d-flex flex-direction-row">
            <img src="assets/images/icons/{{ basicWidget.icon }}" />
            <span class="m-l-5 width-120">{{ basicWidget.title }}</span>
        </div>
        @if (getValueFromResponseMap(basicWidget.title)?.data) {
        <div>
            <b>{{ getValueFromResponseMap(basicWidget.title)?.data.value }}</b>
        </div>
        }
    </div>
    } }
</div>
} @if (!isOnboarded) {
<app-empty-state
    type="noData"
    [title]="'Onboarding in process'"
    subtitle="You don't have any activity yet."
></app-empty-state>
} }
